import React, { useMemo, useState } from "react";
import { Plus, UserCheck, X } from "lucide-react";
import { apiGet } from "../../processes/helpers/api";

export default function PublicationExtraStudentsCard({ values, isSubmitting, onAddStudent, onRemoveStudent }) {
  const [email, setEmail] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [error, setError] = useState("");
  const selectedSet = useMemo(() => new Set(values.studentIds.map(Number)), [values.studentIds]);

  const handleAddByEmail = async () => {
    const trimmedEmail = email.trim().toLowerCase();
    if (!trimmedEmail) {
      setError("Informe o e-mail do aluno.");
      return;
    }

    try {
      setIsAdding(true);
      setError("");
      const params = new URLSearchParams({
        "q[name_or_email_cont]": trimmedEmail,
        paginated: "true",
        page: "1",
        per_page: "10",
      });
      const response = await apiGet(`/api/v2/manager/users?${params.toString()}`);
      const students = response.body?.data || [];
      const student = students.find((item) => item.email?.toLowerCase() === trimmedEmail);

      if (!student) {
        setError("Aluno não encontrado com este e-mail.");
        return;
      }

      if (selectedSet.has(Number(student.id))) {
        setError("Este aluno já foi adicionado.");
        return;
      }

      onAddStudent(student);
      setEmail("");
    } catch {
      setError("Não foi possível buscar este aluno.");
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="teacher-mocks-publication-extra-card">
      <div className="teacher-mocks-publication-extra-title">
        <UserCheck size={14} aria-hidden="true" />
        <strong>Adicionar mais alunos</strong>
        <span>(opcional)</span>
      </div>
      <p>Além dos alunos do curso, você pode adicionar mais alunos por e-mail.</p>
      <label>
        <span>Por e-mail</span>
        <div>
          <input
            type="email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
              if (error) setError("");
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                handleAddByEmail();
              }
            }}
            placeholder="aluno@email.com"
            disabled={isSubmitting || isAdding}
          />
          <button type="button" disabled={isSubmitting || isAdding} onClick={handleAddByEmail}>
            <Plus size={12} aria-hidden="true" />
            {isAdding ? "Buscando..." : "Adicionar"}
          </button>
        </div>
      </label>
      {error && <span className="teacher-mocks-publication-extra-error">{error}</span>}
      {values.studentIds.length > 0 && (
        <div className="teacher-mocks-extra-badges">
          {values.studentIds.map((id) => (
            <span key={id} className="teacher-mocks-extra-badge">
              {values.studentNames[id] || id}
              <button
                type="button"
                onClick={() => onRemoveStudent(id)}
                aria-label="Remover aluno"
                disabled={isSubmitting}
              >
                <X size={10} aria-hidden="true" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
